import { render } from "./REPLY_COMMENT.vue?vue&type=template&id=389d8ca2&ts=true"
import script from "./REPLY_COMMENT.vue?vue&type=script&lang=ts"
export * from "./REPLY_COMMENT.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__